import TextField from "@mui/material/TextField";

const Input = (props: any) => {
  return (
    <TextField
      {...props}
      margin={props.margin || "dense"}
      fullWidth={props.fullWidth || true}
      name={props.id || props.name}
    />
  );
};

export default Input;
